import React, { Component } from 'react';
import './BetResultMatrix.css';

export default class BetResultMatrix extends Component {
  static formatCellValue(val, expand = false) {
    if (typeof val !== 'number') {
      return val;
    }

    if (!expand && Math.abs(val) >= 10000) {
      return BetResultMatrix.shortenNum(val);
    }

    return val.toLocaleString('en-GB');
  }

  static shortenNum(val) {
    // Shorten long numbers using metric prefixes
    return `${(val / 1000).toLocaleString('en-GB', { maximumFractionDigits: 1 })}k`;
  }

  constructor(props) {
    super(props);

    this.state = {
      // Keeps track of cells that have been clicked to reveal full value
      expandedCells: new Array(10).fill().map(() => []),
    };
  }

  expandCell(i, j) {
    const { expandedCells } = this.state;
    expandedCells[i][j] = expandedCells[i][j] !== true;

    this.setState({ expandedCells });
  }

  render() {
    const { data } = this.props;

    return (
      <div className="table-scroll result-matrix">
        <table className="table text-center">
          <thead>
            <tr>
              <th />
              {new Array(data[0].length).fill().map((_, i) =>
                <th className="text-center" key={i}>{i}</th>)}
            </tr>
          </thead>
          <tbody>
            {
              data.map((row, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={i}>
                  <th className="text-right">{i}</th>
                  {row.map((c, j) => (
                    <td
                      key={j}
                      className={`result-matrix__cell ${this.state.expandedCells[i][j] && 'result-matrix__cell--expanded'} ${c > 0 ? 'success' : 'danger'}`}
                      onClick={() => this.expandCell(i, j)}
                    >
                      <i className="result-matrix__short">{BetResultMatrix.formatCellValue(c)}</i>
                      <i className="result-matrix__full">{BetResultMatrix.formatCellValue(c, true)}</i>
                    </td>
                  ))}
                </tr>
              ))
            }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="10" className="result-matrix__legend text-right">All values are in EUR</td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BetResultMatrix/BetResultMatrix.js